var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main feed__container admin__container"},[_c('router-link',{staticClass:"back__link flex",attrs:{"to":"/main"}},[_c('Back'),_c('span',[_vm._v("Powrót")])],1),_c('Upload'),_c('Download'),_c('Users')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }